import {
  Button,
  Typography,
  Dialog,
  DialogContent,
  DialogActions,
  Box,
} from '@mui/material'
import { useLayout } from 'hooks/useLayout'

interface AuthorizeSweepstakesModalProps {
  isModalOpen: boolean
  onClose: () => void
  onSweepstakeModalAccept: () => void
}

export const AuthorizeSweepstakesModal = ({
  isModalOpen,
  onClose,
  onSweepstakeModalAccept,
}: AuthorizeSweepstakesModalProps) => {
  const { isMobile } = useLayout()
  return (
    <Dialog
      fullScreen={isMobile}
      open={isModalOpen}
      onClose={() => {
        onClose()
      }}
      maxWidth={'xl'}
      fullWidth
      PaperProps={{ sx: { p: 0, maxWidth: '400px' } }}
    >
      <DialogContent sx={{ p: 0, zIndex: 0, overflow: 'auto' }}>
        <Box p={2}>
          <Typography variant="body-1">
            By checking this box, you authorize this User to enter sweepstakes
            that may result in a deduction of gaming proceeds.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions className="border-t">
        <Box className="flex flex-row justify-end py-2 md:px-8 sm:px-4">
          <Button
            onClick={() => {
              onClose()
            }}
          >
            Decline
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              onSweepstakeModalAccept()
              onClose()
            }}
          >
            Accept
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}
